var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar-mobile-link", class: _vm.accordionClass },
    [
      _c(
        "a",
        {
          staticClass: "navbar-mobile-link__header",
          class: _vm.headerClass,
          attrs: { href: _vm.link },
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.heading))]),
          _c("icon", {
            attrs: { width: "13px", height: "13px", name: "chevron-right" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }